import {AlertFillIcon, CheckCircleFillIcon, XCircleFillIcon} from '@primer/octicons-react'
import {DeferredCategory, type CategoryDisplay} from '../types/list-types'

export const CATEGORY_MAP: Record<string, CategoryDisplay> = {
  [DeferredCategory.MergeConflicts]: {
    label: 'Merge conflicts',
    variant: 'attention',
    icon: AlertFillIcon,
    iconColor: 'var(--fgColor-attention)',
    iconColorClass: 'attention',
  },
  [DeferredCategory.OutdatedBranch]: {
    label: 'Outdated branch',
    variant: 'attention',
    icon: AlertFillIcon,
    iconColor: 'var(--fgColor-attention)',
    iconColorClass: 'attention',
  },
  [DeferredCategory.ChangesRequested]: {
    label: 'Changes requested',
    variant: 'attention',
    icon: XCircleFillIcon,
    iconColor: 'var(--fgColor-danger)',
    iconColorClass: 'danger',
  },
  [DeferredCategory.CiFailing]: {
    label: 'Checks failing',
    variant: 'danger',
    icon: XCircleFillIcon,
    iconColor: 'var(--fgColor-danger)',
    iconColorClass: 'danger',
  },
  [DeferredCategory.CiRunning]: {label: 'Awaiting CI', variant: 'attention'},
  [DeferredCategory.ReadyToMerge]: {label: 'Ready to merge', variant: 'success'},
  [DeferredCategory.AwaitingReview]: {label: 'Awaiting approval', variant: 'attention'},
  [DeferredCategory.MergeQueue]: {label: 'Queued', variant: 'attention'},
  [DeferredCategory.YourDrafts]: {label: 'Not ready', variant: 'secondary'},
  [DeferredCategory.WaitingForReview]: {label: 'Awaiting approval', variant: 'attention'},
}

export const FALLBACK_CATEGORY: CategoryDisplay = {label: 'Action needed', variant: 'secondary'}

export const OPTIONAL_CHECKS_FAILING: CategoryDisplay = {
  label: 'Able to merge',
  variant: 'attention',
  icon: CheckCircleFillIcon,
  iconColor: 'var(--fgColor-muted)',
  iconColorClass: 'neutral',
}
